import { Button, Dialog } from "@material-ui/core";
import { useStyles } from "./style";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";

const PopUpModalWarning = ({
  open,
  msg,
  title,
  okBtnText,
  cancelBtnText,
  handleOkBtn,
  handleClose,
  handleCancelBtn,
  showCloseIcon = true,
  showOkBtn = true,
  showCancelBtn = true,
  children,
  isDeleteIcon = false,
}) => {
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        className:
          showCancelBtn && showOkBtn
            ? classes.quitDialogWithBothBtn
            : classes.quitDialog,
      }}
    >
      {title && (
        <div
          className={`${classes.popupHeader} ${
            title ? classes.justifyCenter : classes.justifyCenter
          }`}
        >
          {title && <div className={classes.titleText}>{title}</div>}
          {showCloseIcon && (
            <div onClick={handleClose} className={classes.closeIcon}>
              <CloseIcon sx={{ color: "#7A7A7A" }} />
            </div>
          )}
        </div>
      )}
      {msg && <div className={classes.quitDialogText}>{msg}</div>}
      {children && children}
      <div
        className={
          showCancelBtn ? classes.quitDialogBtnContainer : classes.okBtnCenter
        }
      >
        {showCancelBtn && (
          <Button
            onClick={handleCancelBtn}
            className={classes.quitDialogCancelBtn}
          >
            {cancelBtnText}
          </Button>
        )}
        {showOkBtn && (
          <Button
            onClick={handleOkBtn}
            className={classes.quitDialogConfirmBtn}
            style={{ backgroundColor: isDeleteIcon && "#EB5E47" }}
          >
            {okBtnText}
            {isDeleteIcon && <DeleteIcon className={classes.deleteIcon} />}
          </Button>
        )}
      </div>
    </Dialog>
  );
};

export default PopUpModalWarning;
